import $ from "jquery";
import {active} from "./const.js";

$(window).scroll(function() {
  $('#js-bottomCta').css("left", -$(window).scrollLeft());

  if($(this).scrollTop() > 300) {
    $('#js-bottomCta').addClass(active);
  } else {
    $('#js-bottomCta').removeClass(active);
  }
});
